import { Navigate, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import { useEffect, useState } from "react";
import { useToast } from "./ui/use-toast";
import useInternetStatus from "@/hooks/InternetStatus";
import Footer from "./Footer";
import { useAuth } from "@/context/AuthContext";
import CourseHeader from "./CourseHeader";
import Sidebar from "./Sidebar";

const ProtectedLayout = () => {
  const { toast } = useToast();

  const {
    user,
    loading,
  } = useAuth();

  const isOnline = useInternetStatus();

  const [wasOffline, setWasOffline] = useState(false);

  // -----------------------------------------------------------
  // Internet connection status
  // -----------------------------------------------------------
  useEffect(() => {
    if (isOnline && wasOffline) {
      toast({
        variant: "success",
        title: "Back Online",
        description: "Continue your learning",
      });
    }

    if (!isOnline) {
      toast({
        variant: "destructive",
        title: "No Internet",
        description: "Please check your connection",
      });
    }

    setWasOffline(!isOnline);
  }, [isOnline, wasOffline, toast]);

  // -----------------------------------------------------------
  // Wait for Firebase authentication
  // -----------------------------------------------------------
  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-lg font-semibold">
            Loading...
          </div>

          <div className="text-sm text-gray-500 mt-2">
            Checking authentication
          </div>
        </div>
      </div>
    );
  }

  // -----------------------------------------------------------
  // No authenticated Firebase user
  // -----------------------------------------------------------
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  // -----------------------------------------------------------
  // Authenticated application
  // -----------------------------------------------------------
  return (
    <main className="w-screen min-h-screen overflow-hidden">
      <Navbar />

      <CourseHeader />

      <section className="w-full flex justify-between pt-24">
        <div className="hidden md:flex">
          <Sidebar />
        </div>

        <section className="flex-1 h-[calc(100vh-6rem)] overflow-y-auto bg-white">
          <Outlet />
        </section>
      </section>

      <Footer />
    </main>
  );
};

export default ProtectedLayout;